module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Fagus/Nagano_Fagus_MRI_RCP85_Mid.png";